import defaultsDeep from 'lodash/defaultsDeep';
import { Options } from './axios-config';
import BaseConfig from './http.base-instance-config';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { getRegionVariable } from '@white-label-helper/get-region-variable';
//@ts-expect-error - cannot find module export isURL
import isURL from 'validator/lib/isURL';
import { datadogRum } from '@datadog/browser-rum';

const { interceptors } = BaseConfig;
const baseURL = `${getRegionVariable('domains.user')}/v1`;

if (!isURL(baseURL)) {
  // log error if url is not valid
  console.error(`User API Base URL is not valid. Provided url: ${baseURL}`);
  datadogRum.addError(new Error('User API Base URL is not valid'), {
    baseURL,
    partnerName: getAppVariable('partner_name'),
    partnerId: getAppVariable('partner_id'),
  });
}

interface UserInstance extends Options {
  baseURL: string | undefined;
}

const options: UserInstance = defaultsDeep(
  {
    baseURL,
    headers: {
      Authorization: `Bearer ${getAppVariable('channel.token')}`,
    },
  },
  BaseConfig.options
);

export default {
  interceptors,
  options,
};
